export const ONGOING = "ongoing"; // haven't submitted even once
export const WITHDRAWN = "withdrawn"; // submitted but withdrawn
export const DECLINED = "declined"; // submitted but declined by the manager
export const APPROVED = "approved"; // submitted and approved by the manager
export const PENDING = "pending"; // submitted but not yet approved or declined
export const DRAFT = "draft"; // saved but not submitted
export const TOTAL_WORKING_HOURS = 8;
export const MAX_WORKING_HOURS = 12;
export const MIN_WORKING_HOURS = 8;
